interface AnalyticsTabButtonProps {
  isActive: boolean;
  onClick: () => void;
  label: string;
}

export function AnalyticsTabButton({ isActive, onClick, label }: AnalyticsTabButtonProps) {
  return (
    <button
      onClick={onClick}
      className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
        isActive
          ? 'bg-brand text-white shadow-sm'
          : 'text-gray-600 hover:text-gray-900'
      }`}
    >
      {label}
    </button>
  );
}
